module.exports = __webpack_public_path__ + "static/media/8.f651ef7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/8.png
// module id = 1503
// module chunks = 0